<template>
	<div>
		<settings-alerts
			:isError="isError"
			:isSuccess="isSuccess"
			@toggleSucces="(value) => (isSuccess = value)"
			@toggleError="(value) => (isError = value)"
		/>

		<avatar-settings />
		<div class="mt-2">
		<div class="d-flex flex-row mb-2 w-100">
			<div class="mr-6 w-100">
				<div
					class="grey--text text--darken-2 font-weight-black mb-1"
				>
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.account.firstName"
						)
					}}
				</div>
				<v-text-field
					v-model="firstName"
					:disabled="!isEditUserData"
					dense
					hide-details
					outlined
					block
				></v-text-field>
			</div>

			<div class="w-100" >
				<div
					class="grey--text text--darken-2 font-weight-black mb-1"
				>
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.account.lastName"
						)
					}}
				</div>
				<v-text-field
					v-model="lastName"
					:disabled="!isEditUserData"
					dense
					outlined
					block
					hide-details
				></v-text-field>
			</div>
		</div>
		<div class="d-flex flex-row justify-content-right">
			<v-btn
				@click="toggleEditData()"
				v-if="!isEditUserData"
				color="accent"
				elevation="0"
				height="32"
				class="ml-auto"
			>
				{{
					$vuetify.lang.t("$vuetify.views.settings.account.editData")
				}}
			</v-btn>
			<v-btn
				@click="toggleEditData()"
				v-if="isEditUserData"
				color="background"
				elevation="0"
				height="32"
			>
				{{ $vuetify.lang.t("$vuetify.views.settings.account.cancel") }}
			</v-btn>
			<v-btn
				@click="editUserData()"
				v-if="isEditUserData"
				color="accent"
				elevation="0"
				height="32"
				class="ml-1"
				:loading="isUserLoading"
			>
				{{
					$vuetify.lang.t(
						"$vuetify.views.settings.account.saveChanges"
					)
				}}
			</v-btn>
		</div>
			
		</div>


		<div>
			<div
				class="grey--text text--darken-2 font-weight-black mb-1"
			>
				{{ $vuetify.lang.t("$vuetify.views.settings.account.email") }}
			</div>
			<v-text-field
				dense
				disabled
				outlined
				:value="user.email"
			></v-text-field>
		</div>

		<div v-if="!isEditUserPassword">
			<div
				class="grey--text text--darken-2 font-weight-black mb-1"
			>
				{{
					$vuetify.lang.t("$vuetify.views.settings.account.password")
				}}
			</div>
			<v-text-field
				dense
				disabled
				outlined
				hide-details=""
				type="password"
				value="wqfasds222"
			></v-text-field>
		</div>

		<div v-else>
			<div
				class="grey--text text--darken-2 font-weight-black mb-1"
			>
				{{
					$vuetify.lang.t(
						"$vuetify.views.settings.account.typeActualPassword"
					)
				}}
			</div>
			<v-text-field
				v-model="oldPassword"
				dense
				outlined
				type="password"
			></v-text-field>
		

			<div
				class="grey--text text--darken-2 font-weight-black mb-1"
			>
				{{
					$vuetify.lang.t(
						"$vuetify.views.settings.account.typeNewPassword"
					)
				}}
			</div>
			<v-text-field
				v-model="newPassword"
				:rules="[rules.min, rules.hasNumber, rules.hasCapital]"
				dense
				outlined
				type="password"
				:hint="
					$vuetify.lang.t(
						'$vuetify.views.settings.account.passwordHint'
					)
				"
			></v-text-field>
			<div
				class="grey--text text--darken-2 font-weight-black mb-1"
			>
				{{
					$vuetify.lang.t(
						"$vuetify.views.settings.account.passwordAgain"
					)
				}}
			</div>
			<v-text-field
				v-model="newPasswordRepeat"
				:rules="[rules.passwordMatch]"
				dense
				outlined
				type="password"
			></v-text-field>
			<div class="text-right">
				<v-btn
					@click="toggleEditPassword()"
					v-if="isEditUserPassword"
					color="background"
					elevation="0"
					height="32"
					class="mr-2"
				>
					{{ $vuetify.lang.t("$vuetify.views.settings.account.cancel") }}
				</v-btn>
				<v-btn
					@click="editPassword()"
					v-if="isEditUserPassword"
					color="accent"
					elevation="0"
					height="32"
					:loading="isPasswordLoading"
				>
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.account.savePassword"
						)
					}}
				</v-btn>
			</div>
		</div>	
		<div v-if="!isEditUserPassword" class="text-right mt-2">
			<v-btn
				@click="toggleEditPassword()"
				color="accent"
				elevation="0"
				height="32"
			>
				{{
					$vuetify.lang.t("$vuetify.views.settings.account.editPassword")
				}}
			</v-btn>
		</div>

		<!-- <div class="mb-2 font-weight-bold subtitle-1 grey--text text--darken-2">
			{{ $vuetify.lang.t("$vuetify.views.settings.account.language") }}
		</div>
		<v-menu top offset-y>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					v-bind="attrs"
					v-on="on"
					height="32"
					class="mb-2 menu-btn select-btn"
					color="background lighten-1"
				>
					<div class="subtitle-2 font-weight-bold pr-2">
						<v-icon class="mr-3">{{ selectLangObj.icon }} </v-icon>
						{{ selectLangObj.name }}
					</div>
					<v-icon>mdi-chevron-down </v-icon>
				</v-btn>
			</template>
			<v-list>
				<v-list-item-group>
					<v-list-item
						link
						class="list-item subtitle-1 d-flex justify-center"
						v-for="lang in langs"
						:key="lang.name"
						@click="changeLang(lang.code)"
					>
						<div
							class="subtitle-1 font-weight-bold d-flex justify-center"
						>
							<v-icon class="mr-3">{{ lang.icon }}</v-icon>
							<span class="subtitle-1 font-weight-bold">
								{{ lang.name }}
							</span>
						</div>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-menu> -->
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

import AvatarSettings from "@/components/settings/AvatarSettings";
import SettingsAlerts from "@/components/settings/SettingsAlerts";

export default {
	name: "UserSettings",
	components: {
		SettingsAlerts,
		AvatarSettings,
	},

	data() {
		return {
			firstName: "",
			lastName: "",
			isEditUserData: false,
			isEditUserPassword: false,
			isSuccess: false,
			isError: false,
			isUserLoading: false,
			isPasswordLoading: false,
			oldPassword: "",
			newPassword: "",
			newPasswordRepeat: "",
			selectLang: "Polski",
			langs: [
				{ code: "pl", name: "Polski", icon: "$pl-flag" },
				{ code: "en", name: "English", icon: "$ang-flag" },
			],
			rules: {
				passwordMatch: () =>
					this.newPassword === this.newPasswordRepeat ||
					"Hasła różnią się od siebie",
				min: (v) => v.length >= 8 || "Hasło musi zawierać 8 znaków",
				hasNumber: (v) => /\d/.test(v) || "Hasło musi zawierać cyfrę",
				hasCapital: (v) => {
					let condition;
					for (let i = 0; i < v.length; i++) {
						if (/^[A-Z]*$/.test(v[i])) {
							condition = true;
						}
					}
					return condition || "Hasło musi zawierać dużą literę";
				},
			},
		};
	},
	computed: {
		...mapGetters({ user: "auth/user" }),
		selectLangObj() {
			const selectedObj = this.langs.filter((lang) => {
				return lang.code === this.user.locale;
			})[0];
			return selectedObj;
		},
	},
	methods: {
		...mapActions({ updateUser: "auth/updateUser" }),
		toggleEditData() {
			this.isEditUserData = !this.isEditUserData;
		},
		toggleEditPassword() {
			this.isEditUserPassword = !this.isEditUserPassword;
		},
		async editUserData() {
			this.isUserLoading = true;

			const first_name = this.firstName || this.user.name.split(" ")[0];
			const last_name = this.lastName || this.user.name.split(" ")[1];

			const res = await this.updateUser({ first_name, last_name });

			this.isUserLoading = false;
			this.toggleEditData();

			if (res) {
				this.isSuccess = true;
			} else {
				this.isError = true;
			}
		},
		async editPassword() {
			let conditions =
				this.newPassword === this.newPasswordRepeat &&
				this.newPassword.length >= 8 &&
				/\d/.test(this.newPassword) &&
				this.newPassword &&
				this.oldPassword;

			if (conditions) {
				conditions = false;
				for (let i = 0; i < this.newPassword.length; i++) {
					if (/^[A-Z]*$/.test(this.newPassword[i])) {
						conditions = true;
					}
				}
			}

			if (conditions) {
				const password_old = this.oldPassword;
				const password_new = this.newPassword;
				const password_new_confirmation = this.newPasswordRepeat;

				this.isPasswordLoading = true;

				await axios
					.patch("users/update-password", {
						password_old,
						password_new,
						password_new_confirmation,
					})
					.then((response) => {
						if (response.message) {
							this.isError = true;
						} else {
							this.isSuccess = true;
						}
					})
					.catch((e) => {
						console.log("UPDATE PASSWORD ERROR", e);
						this.isError = true;
					});

				this.isPasswordLoading = false;
			} else {
				this.isError = true;
			}
		},
		async changeLang(lang) {
			await axios
				.patch("users/update-language", { language: lang })
				.then((response) => {
					if (response.data && response.data.data) {
						this.$store.commit("auth/setUser", response.data.data);
						this.$vuetify.lang.current = lang;
						this.$router.go(0);
					}
				})
				.catch((e) => {
					console.log("CHANGE LANGUAGE ERROR", e);
				});
		},
		setData() {
			let splitted = this.user.name.split(' ');
			this.firstName = splitted[0];
			this.lastName = splitted.length == 2 ? splitted[1] : '';
		}
	},
	created() {
		this.setData();
	}
};
</script>

<style scoped lang="scss">
.avatar-instruction {
	max-width: 492px;
	line-height: 1.5;
}
</style>
